import * as React from 'react';
import { CourseLine } from './CourseLine';
import { TableChorinitia } from '../../genericComponents/TableChorinitia/TableChorinitia';
import * as ReqType from '../../../types/ServerRequests';
import { CoursService } from '../../../services/CoursService';
import { DatetimeForm } from '../../genericComponents/Date/DatetimeForm';

export interface Props {
}

interface State {
    listCourses: ReqType.Course[];
    dateDebut: Date;
    dateFin: Date;
    heureDebut: Date;
    heureFin: Date;
}

/**
 * Ce composant permet d'afficher la liste des cours depuis le portail surperAdmin
 */
export class ListCourse extends React.Component {
    props: Props;
    state: State;

    constructor(props: Props) {
        super(props);
        this.state = {
            listCourses: [],
            dateDebut: new Date(),
            dateFin: new Date(),
            heureDebut: new Date(),
            heureFin: new Date(),
        };
        this.getCourses();
    }

    handleselecteur = (e: React.ChangeEvent<HTMLSelectElement>) => {
        this.setState({ selecteurtrie: e.target.value });
    }

    render() {

        var listItems = this.state.listCourses.map(
            (course: ReqType.Course, index: number) => {
                if (course.status === 0) {
                    return undefined;
                }
                return (
                    <CourseLine
                        course={course}
                        key={index}
                        dateDebut={this.state.dateDebut}
                        dateFin={this.state.dateFin}
                        heureDebut={this.state.heureDebut}
                        heureFin={this.state.heureFin}
                    />
                );
            }
        );

        return (
            <div>
                <div>
                    <label>Date debut</label>
                    <DatetimeForm
                        date={this.state.dateDebut}
                        disabled={false}
                        hour={false}
                        setDate={
                            (d: Date) => {
                                this.setState({dateDebut: d});
                            }
                        }
                    />
                    <label>Date fin</label>
                    <DatetimeForm
                        date={this.state.dateFin}
                        disabled={false}
                        hour={false}
                        setDate={
                            (d: Date) => {
                                this.setState({dateFin: d});
                            }
                        }
                    />
                    <label>Heure debut</label>
                    <DatetimeForm
                        date={this.state.heureDebut}
                        disabled={false}
                        day={false}
                        setDate={
                            (d: Date) => {
                                this.setState({heureDebut: d});
                            }
                        }
                    />
                    <label>Heure fin</label>
                    <DatetimeForm
                        date={this.state.heureFin}
                        disabled={false}
                        day={false}
                        setDate={
                            (d: Date) => {
                                this.setState({heureFin: d});
                            }
                        }
                    />
                </div>
                <div id="tableau">
                    <TableChorinitia
                        header={
                            <thead className="thead-light">
                                <tr>
                                    <th scope="col">Discipline</th>
                                    <th scope="col">Niveau</th>
                                    <th scope="col">Detail</th>
                                    <th scope="col">Adresse</th>
                                    <th scope="col" />
                                </tr>
                            </thead>
                        }
                    >
                        <tbody >
                            {listItems}
                        </tbody>
                    </TableChorinitia>
                </div>
            </div>
        );
    }

    private getCourses() {
        CoursService.getInstance().getCoursList(
        ).then(
            (response: ReqType.Course[]) => {
                this.setState({ listCourses: response });
            }
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/SuperAdminPage/internalComponents/ListCourse.tsx